import { default as _indexWySi5dQZGTMeta } from "/var/www/cilek-kids.ru/frontend/cilek-front-20250604133628/pages/_index.vue?macro=true";
import { default as _91_46_46_46cms_9376HjZK0iUfMeta } from "/var/www/cilek-kids.ru/frontend/cilek-front-20250604133628/pages/[...cms].vue?macro=true";
import { default as indexrVBLspcOg5Meta } from "/var/www/cilek-kids.ru/frontend/cilek-front-20250604133628/pages/cart/index.vue?macro=true";
import { default as indexuYZVHUb7WYMeta } from "/var/www/cilek-kids.ru/frontend/cilek-front-20250604133628/pages/cart/success/index.vue?macro=true";
import { default as _91_46_46_46slug_93bwlv0Ym5KtMeta } from "/var/www/cilek-kids.ru/frontend/cilek-front-20250604133628/pages/catalog/[...slug].vue?macro=true";
import { default as indexNUI5NnTjgUMeta } from "/var/www/cilek-kids.ru/frontend/cilek-front-20250604133628/pages/catalog/index.vue?macro=true";
import { default as _91_46_46_46slug_93hmPZxZFPjkMeta } from "/var/www/cilek-kids.ru/frontend/cilek-front-20250604133628/pages/collection/[...slug].vue?macro=true";
import { default as indexrYrMPg5h70Meta } from "/var/www/cilek-kids.ru/frontend/cilek-front-20250604133628/pages/email/index.vue?macro=true";
import { default as indexSRdZizlOG4Meta } from "/var/www/cilek-kids.ru/frontend/cilek-front-20250604133628/pages/kontakty/index.vue?macro=true";
import { default as _91_46_46_46slug_93NXgTr6KA6pMeta } from "/var/www/cilek-kids.ru/frontend/cilek-front-20250604133628/pages/product/[...slug].vue?macro=true";
import { default as indexcDIjHSYT1LMeta } from "/var/www/cilek-kids.ru/frontend/cilek-front-20250604133628/pages/search/index.vue?macro=true";
import { default as indexkcaBPGMOw3Meta } from "/var/www/cilek-kids.ru/frontend/cilek-front-20250604133628/pages/wishlist/index.vue?macro=true";
export default [
  {
    name: _indexWySi5dQZGTMeta?.name ?? "_index",
    path: _indexWySi5dQZGTMeta?.path ?? "/_index",
    meta: _indexWySi5dQZGTMeta || {},
    alias: _indexWySi5dQZGTMeta?.alias || [],
    redirect: _indexWySi5dQZGTMeta?.redirect,
    component: () => import("/var/www/cilek-kids.ru/frontend/cilek-front-20250604133628/pages/_index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46cms_9376HjZK0iUfMeta?.name ?? "cms",
    path: _91_46_46_46cms_9376HjZK0iUfMeta?.path ?? "/:cms(.*)*",
    meta: _91_46_46_46cms_9376HjZK0iUfMeta || {},
    alias: _91_46_46_46cms_9376HjZK0iUfMeta?.alias || [],
    redirect: _91_46_46_46cms_9376HjZK0iUfMeta?.redirect,
    component: () => import("/var/www/cilek-kids.ru/frontend/cilek-front-20250604133628/pages/[...cms].vue").then(m => m.default || m)
  },
  {
    name: indexrVBLspcOg5Meta?.name ?? "cart",
    path: indexrVBLspcOg5Meta?.path ?? "/cart",
    meta: indexrVBLspcOg5Meta || {},
    alias: indexrVBLspcOg5Meta?.alias || [],
    redirect: indexrVBLspcOg5Meta?.redirect,
    component: () => import("/var/www/cilek-kids.ru/frontend/cilek-front-20250604133628/pages/cart/index.vue").then(m => m.default || m)
  },
  {
    name: indexuYZVHUb7WYMeta?.name ?? "cart-success",
    path: indexuYZVHUb7WYMeta?.path ?? "/cart/success",
    meta: indexuYZVHUb7WYMeta || {},
    alias: indexuYZVHUb7WYMeta?.alias || [],
    redirect: indexuYZVHUb7WYMeta?.redirect,
    component: () => import("/var/www/cilek-kids.ru/frontend/cilek-front-20250604133628/pages/cart/success/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93bwlv0Ym5KtMeta?.name ?? "catalog-slug",
    path: _91_46_46_46slug_93bwlv0Ym5KtMeta?.path ?? "/catalog/:slug(.*)*",
    meta: _91_46_46_46slug_93bwlv0Ym5KtMeta || {},
    alias: _91_46_46_46slug_93bwlv0Ym5KtMeta?.alias || [],
    redirect: _91_46_46_46slug_93bwlv0Ym5KtMeta?.redirect,
    component: () => import("/var/www/cilek-kids.ru/frontend/cilek-front-20250604133628/pages/catalog/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexNUI5NnTjgUMeta?.name ?? "catalog",
    path: indexNUI5NnTjgUMeta?.path ?? "/catalog",
    meta: indexNUI5NnTjgUMeta || {},
    alias: indexNUI5NnTjgUMeta?.alias || [],
    redirect: indexNUI5NnTjgUMeta?.redirect,
    component: () => import("/var/www/cilek-kids.ru/frontend/cilek-front-20250604133628/pages/catalog/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93hmPZxZFPjkMeta?.name ?? "collection-slug",
    path: _91_46_46_46slug_93hmPZxZFPjkMeta?.path ?? "/collection/:slug(.*)*",
    meta: _91_46_46_46slug_93hmPZxZFPjkMeta || {},
    alias: _91_46_46_46slug_93hmPZxZFPjkMeta?.alias || [],
    redirect: _91_46_46_46slug_93hmPZxZFPjkMeta?.redirect,
    component: () => import("/var/www/cilek-kids.ru/frontend/cilek-front-20250604133628/pages/collection/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexrYrMPg5h70Meta?.name ?? "email",
    path: indexrYrMPg5h70Meta?.path ?? "/email",
    meta: indexrYrMPg5h70Meta || {},
    alias: indexrYrMPg5h70Meta?.alias || [],
    redirect: indexrYrMPg5h70Meta?.redirect,
    component: () => import("/var/www/cilek-kids.ru/frontend/cilek-front-20250604133628/pages/email/index.vue").then(m => m.default || m)
  },
  {
    name: indexSRdZizlOG4Meta?.name ?? "kontakty",
    path: indexSRdZizlOG4Meta?.path ?? "/kontakty",
    meta: indexSRdZizlOG4Meta || {},
    alias: indexSRdZizlOG4Meta?.alias || [],
    redirect: indexSRdZizlOG4Meta?.redirect,
    component: () => import("/var/www/cilek-kids.ru/frontend/cilek-front-20250604133628/pages/kontakty/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93NXgTr6KA6pMeta?.name ?? "product-slug",
    path: _91_46_46_46slug_93NXgTr6KA6pMeta?.path ?? "/product/:slug(.*)*",
    meta: _91_46_46_46slug_93NXgTr6KA6pMeta || {},
    alias: _91_46_46_46slug_93NXgTr6KA6pMeta?.alias || [],
    redirect: _91_46_46_46slug_93NXgTr6KA6pMeta?.redirect,
    component: () => import("/var/www/cilek-kids.ru/frontend/cilek-front-20250604133628/pages/product/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexcDIjHSYT1LMeta?.name ?? "search",
    path: indexcDIjHSYT1LMeta?.path ?? "/search",
    meta: indexcDIjHSYT1LMeta || {},
    alias: indexcDIjHSYT1LMeta?.alias || [],
    redirect: indexcDIjHSYT1LMeta?.redirect,
    component: () => import("/var/www/cilek-kids.ru/frontend/cilek-front-20250604133628/pages/search/index.vue").then(m => m.default || m)
  },
  {
    name: indexkcaBPGMOw3Meta?.name ?? "wishlist",
    path: indexkcaBPGMOw3Meta?.path ?? "/wishlist",
    meta: indexkcaBPGMOw3Meta || {},
    alias: indexkcaBPGMOw3Meta?.alias || [],
    redirect: indexkcaBPGMOw3Meta?.redirect,
    component: () => import("/var/www/cilek-kids.ru/frontend/cilek-front-20250604133628/pages/wishlist/index.vue").then(m => m.default || m)
  }
]